import { useMemo } from 'react';
import {
  EDM_LEASE_DEALS_VEHICLE_CARD_CREATIVE_ID,
  EDM_LEASE_DEALS_VEHICLE_DETAIL_CREATIVE_ID,
} from 'site-modules/lease-deals/constants/lease-deals-constants';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { useWebShare } from 'site-modules/shared/hooks/use-web-share/use-web-share';
import PropTypes from 'prop-types';
import { getShareData } from 'site-modules/lease-deals/utils/get-share-data';

export const SHARE_CONSTANTS = {
  IMAGE_SRC: '/icons/youtube-share.svg',
  UNSUPPORTED_TITLE: 'Sharing functionality is not supported by your browser.',
};

export const WithLeaseShare = ({ year, make, model, id, styleId, shareSource = 'card', children }) => {
  const shareData = useMemo(
    () => getShareData({ year, make, model, id, shareSource }),
    [year, make, model, id, shareSource]
  );

  const { isSupported, share } = useWebShare(shareData);

  const fireTracking = status => {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        action_name: TrackingConstant.ACTION_SHARE_CONTENT,
        subaction_name: status,
        action_category: TrackingConstant.USER_ACTION_CATEGORY,
        action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
        creative_id:
          shareSource === 'card'
            ? EDM_LEASE_DEALS_VEHICLE_CARD_CREATIVE_ID
            : EDM_LEASE_DEALS_VEHICLE_DETAIL_CREATIVE_ID,
        value: `${styleId}`,
      },
    });
  };

  const handleShare = () => {
    fireTracking('share_started');
    share({
      onSuccess: () => {
        fireTracking('share_completed');
      },
      onError: () => {
        fireTracking('share_failed');
      },
    });
  };

  return children({
    onShare: handleShare,
    isSupported,
    imageSrc: SHARE_CONSTANTS.IMAGE_SRC,
    title: !isSupported ? SHARE_CONSTANTS.UNSUPPORTED_TITLE : undefined,
  });
};

WithLeaseShare.propTypes = {
  children: PropTypes.func.isRequired,
  styleId: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
  shareSource: PropTypes.string,
};
